function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#98ABC7",
  fillRule: "nonzero",
  d: "M3.701 7.896l5.778-5.94c.3-.277.425-.702.328-1.104a1.108 1.108 0 0 0-.793-.818A1.074 1.074 0 0 0 7.94.367L.294 8.227a.793.793 0 0 0-.186.259c0 .034-.038.067-.055.107l-.033.112a.63.63 0 0 0 0 .095 1.212 1.212 0 0 0 0 .444.889.889 0 0 0 0 .095l.033.113c0 .039.038.072.055.106.014.03.03.058.049.084.038.061.082.118.131.169l7.646 7.86a1.072 1.072 0 0 0 1.545 0 1.146 1.146 0 0 0 0-1.589l-5.778-5.94c-.388-.404-.583-.743-.583-1.016s.195-.683.583-1.23z"
});

function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.a38ff586.svg";
export { ForwardRef as ReactComponent };